import { v4 as uuid } from 'uuid';
import { Types } from './actions';

export const INITIAL_STATE = {
  count: 0,
  notifications: [],
};

export default function newNotifications(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case Types.UPDATE_NEW_NOTIFICATIONS:
      return {
        ...state,
        count: action.value,
      };
    case Types.SHOW_NOTIFICATIONS:
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            title: action.title,
            body: action.body,
            id: uuid(),
          },
        ],
      };
    default:
      return {
        ...state,
      };
  }
}
